import React__default from 'react';
import cn from 'classnames';
import { Root, Header, Trigger as Trigger$1, Content as Content$1, Item as Item$1 } from '@radix-ui/react-accordion';
import { Icon } from '../Icon/Icon.js';

const AccordionContext = /*#__PURE__*/React__default.createContext({
  as: 'h2'
});
const StyledTrigger = /*#__PURE__*/React__default.forwardRef(function AccordionStyledTrigger(props, ref) {
  const isExpanded = !!props['aria-expanded'];
  const className = cn('w-full inline-flex justify-between items-center align-middle', 'focus:rounded-sm focus:border-blue focus:yt-focus', props.className);
  return React__default.createElement("button", Object.assign({}, props, {
    ref: ref,
    className: className
  }), props.children, React__default.createElement(Icon, {
    name: isExpanded ? 'chevron-up' : 'chevron-down'
  }));
});
const Trigger = /*#__PURE__*/React__default.forwardRef(function AccordionTrigger(props, ref) {
  const {
    children
  } = props;
  const {
    as: Heading
  } = React__default.useContext(AccordionContext);
  return React__default.createElement(Header, {
    asChild: true
  }, React__default.createElement(Heading, {
    className: "my-3"
  }, React__default.createElement(Trigger$1, {
    ref: ref,
    asChild: true
  }, React__default.createElement(StyledTrigger, null, children))));
});
const Content = /*#__PURE__*/React__default.forwardRef(function AccordionContent(props, ref) {
  return React__default.createElement(Content$1, Object.assign({}, props, {
    ref: ref
  }));
});

const Item = props => {
  const {
    id,
    ...otherProps
  } = props;
  return React__default.createElement(Item$1, Object.assign({}, otherProps, {
    value: id
  }));
};

const Accordion = props => {
  const {
    id,
    defaultId,
    onChange,
    as = 'h2',
    ...otherProps
  } = props;
  const context = React__default.useMemo(() => ({
    as
  }), [as]);
  let valueProps;

  if (defaultId) {
    valueProps = {
      defaultValue: defaultId || undefined
    };
  } else {
    valueProps = {
      onValueChange: onChange,
      value: id || undefined
    };
  }

  const type = Array.isArray(valueProps.defaultValue) || Array.isArray(valueProps.value) ? 'multiple' : 'single';
  const className = cn('divide-y divide-grey', props.className);
  return React__default.createElement(AccordionContext.Provider, {
    value: context
  }, React__default.createElement(Root, Object.assign({}, otherProps, valueProps, {
    "data-taco": "accordion",
    className: className,
    type: type
  })));
};
Accordion.Item = Item;
Accordion.Trigger = Trigger;
Accordion.Content = Content;

export { Accordion };
//# sourceMappingURL=Accordion.js.map
